import { render, staticRenderFns } from "./PolygonInput.vue?vue&type=template&id=1ca3ac70&"
import script from "./PolygonInput.vue?vue&type=script&lang=js&"
export * from "./PolygonInput.vue?vue&type=script&lang=js&"
import style0 from "./PolygonInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports